import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {BuilderPaneBase} from 'common/widgets/cohorts-query-builder/common-components/builder-pane-base/index';
import {FUNNEL_CLAUSE_OPERATOR} from 'common/widgets/cohorts-query-builder/models/constants';
import {replaceByIndex} from 'common/widgets/cohorts-query-builder/util/index';
import {isEventLiteral} from 'common/widgets/cohorts-query-builder/util/staged-cohort';

import template from './index.jade';
import css from './index.styl?inline';

const OPERATOR_LABEL_TO_OPERATOR = {
  any: `or`,
  all: `and`,
  then: FUNNEL_CLAUSE_OPERATOR,
  or: `or`,
  and: `and`,
};

const OPERATOR_TO_OPERATOR_LABEL = {
  or: `any`,
  and: `all`,
};

class ClauseOperatorBuilderClauseOperator extends BuilderPaneBase {
  get config() {
    return {
      ...super.config,
      useShadowDom: true,
      css,
      template,
      helpers: {
        ...super.config.helpers,
        isFunnelSelected: () => this.literal.isFunnel,
        hasMultipleSubClauses: () => this.hasMultipleSubClauses,
        getClauseOperatorLabel: () => {
          const [firstOperator, secondOperator] = this.clauseOperators;
          let label;
          if (!firstOperator) {
            label = `then`;
          } else if (!this.hasMultipleSubClauses) {
            label = firstOperator;
          } else {
            label = `${firstOperator} ${OPERATOR_TO_OPERATOR_LABEL[secondOperator]}`;
          }

          return label;
        },
        getClauseOperatorParts: () => {
          let clauseOperatorParts;
          if (isEventLiteral(this.literal)) {
            clauseOperatorParts = [[`or`, `and`, `then`]];
          } else {
            clauseOperatorParts = [[`or`, `and`]];
          }

          return this.hasMultipleSubClauses ? [...clauseOperatorParts, [`any`, `all`]] : clauseOperatorParts;
        },
        isPartSelected: (part, idx) => {
          const clauseOperator = this.clauseOperators[idx];
          const isFunnelSelected = this.helpers.isFunnelSelected();
          return OPERATOR_LABEL_TO_OPERATOR[part] === clauseOperator && (idx === 0 || !isFunnelSelected);
        },
        clickedOperatorPart: (operatorPart, idx) => {
          const operator = OPERATOR_LABEL_TO_OPERATOR[operatorPart];
          this.dispatchBubbledEvent(`selected-clause-operators`, replaceByIndex(this.clauseOperators, idx, operator));
        },
      },
    };
  }

  get literal() {
    return this.state.stagedCohort.literals[this.state.stagedClausePosition.literalIdx];
  }

  get clauseOperators() {
    return this.state.stagedCohort.getClauseOperators(this.state.stagedClausePosition.literalIdx);
  }

  get hasMultipleSubClauses() {
    return this.literal.clauses.length > 2;
  }
}

export const ClauseOperatorBuilderClauseOperatorEl = defineAndMakeJsxFactory(
  `cohorts-builder-clause-operator`,
  ClauseOperatorBuilderClauseOperator,
);
